import { Country, State } from "country-state-city";
import {
  backend_url,
  uninterceptedAxiosInstance,
} from "../common/commonVariables";

export const deleteVendor = async (ID, reason) => {
  try {
    let params = {
      data: [
        {
          id: ID,
          deleteReason: reason,
        },
      ],
    };
    const response = await uninterceptedAxiosInstance.post(
      backend_url + "vendors/removeVendors",
      params,
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response;

    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }
    return {
      status: err.response.status,
      error: err.response?.data?.error,
    };
  }
};

export const createNewVendor = async (
  name,
  address,
  phone,
  website,
  email,
  serviceType,
  description,
  billingInformation,
  logo,
  organisation = "",
  createdByUser = null,
  Industry,
  contactInformation,
  creditDays,
  startDate,
  endDate,
  location,
  preferences
) => {
  try {
    let params = {
      name,
      address,
      phone,
      website,
      email,
      serviceType,
      description,
      logo,
      billingInformation,
      organisation,
      createdByUser,
      Industry,
      contactInformation,
      creditDays,
      startDate,
      endDate,
      location,
      preferences,
    };

    if (params?.billingInformation?.country) {
      params.billingInformation.countryName = Country.getCountryByCode(
        params?.billingInformation?.country
      )?.name;
    }
    if (params?.billingInformation?.city) {
      const citiesOfCountry = State.getStatesOfCountry(
        params.billingInformation.country
      );
      const the_city = params.billingInformation.city
        ? citiesOfCountry.filter((city) => {
            return city.isoCode == params.billingInformation.city;
          })[0].name
        : "";
      params.billingInformation.cityName = the_city;
    }

    const response = await uninterceptedAxiosInstance.post(
      backend_url + "vendors",
      { data: params },
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response;
    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }

    return {
      status: err.response.status,
      error: err.response?.data?.error,
    };
  }
};

export const updateVendor = async (
  id,
  name,
  address,
  phone,
  website,
  email,
  serviceType,
  description,
  billingInformation,
  logo,
  location,
  Industry,
  contactInformation,
  startDate,
  endDate,
  creditDays,
  organisation,
  preferences
) => {
  try {
    let params = {
      name,
      address,
      phone,
      website,
      email,
      logo,
      serviceType,
      description,
      location,
      Industry,
      contactInformation,
      billingInformation,
      startDate,
      endDate,
      creditDays,
      organisation,
      preferences,
    };

    if (params?.billingInformation?.country) {
      params.billingInformation.countryName = Country.getCountryByCode(
        params?.billingInformation?.country
      )?.name;
    }
    if (params?.billingInformation?.city) {
      const citiesOfCountry = State.getStatesOfCountry(
        params.billingInformation.country
      );
      const the_city = params.billingInformation.city
        ? citiesOfCountry.filter((city) => {
            return city.isoCode == params.billingInformation.city;
          })[0].name
        : "";
      params.billingInformation.cityName = the_city;
    }

    const response = await uninterceptedAxiosInstance.put(
      backend_url + "vendors/" + id,
      { data: params },
      {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      }
    );

    let the_response = response;
    return the_response;
  } catch (err) {
    if (err.response) {
    } else if (err.request) {
    } else {
    }

    return {
      status: err.response.status,
      error: err.response?.data?.error,
    };
  }
};
